import * as React from 'react';
import FacebookLogin from 'react-facebook-login';

class FacebookPosts extends React.Component {
    public constructor(props) {
        super(props);
    }


    public render() {
        return (
            <div>
                <FacebookLogin
                    appId="938568736270505"
                    autoLoad={true}
                    fields="posts"
                    onClick={this.componentClicked}
                    callback={this.responseFacebook} />
            </div>
        );

    }
    private responseFacebook = (response) => {
        console.log(response);
    }
    private componentClicked = (event) => {
        console.log(event);
    }
}

export default FacebookPosts;



// WEBPACK FOOTER //
// ./src/Home/FacebookPosts/FacebookPosts.tsx